var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFbShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "details-",
    transform: "translate(-874.000000, -1897.000000)",
    fill: "#828A9C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 1797.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_ik",
    transform: "translate(865.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(9.750000, 6.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53747002,2.1624347 L7.28327338,2.1624347 C7.44396912,2.1624347 7.5742497,2.04140546 7.5742497,1.89212086 L7.5742497,0.270288499 C7.5742497,0.12102924 7.44396912,0 7.28327338,0 L5.53747002,0 C3.77060791,0.00179922027 2.3387491,1.33195517 2.33683963,2.97335088 L2.33683963,4.86549708 L0.300059952,4.86549708 C0.139364209,4.86549708 0.00908363309,4.98652632 0.00908363309,5.13581092 L0.00908363309,6.75764327 C0.00908363309,6.90692788 0.139364209,7.02795712 0.300059952,7.02795712 L2.33683963,7.02795712 L2.33683963,12.7043704 C2.33683963,12.853655 2.4671202,12.9746842 2.62781595,12.9746842 L4.3736193,12.9746842 C4.53431505,12.9746842 4.66459562,12.853655 4.66459562,12.7043704 L4.66459562,7.02795712 L6.7013753,7.02795712 C6.82655486,7.02788109 6.93765887,6.95340351 6.97721223,6.84306823 L7.55913759,5.22123587 C7.60992956,5.07960429 7.5274949,4.92654386 7.37503717,4.87935867 C7.34546763,4.87021053 7.31447962,4.86552242 7.28330066,4.86549708 L4.66459562,4.86549708 L4.66459562,2.97335088 C4.66456835,2.52549708 5.05538279,2.1624347 5.53747002,2.1624347 Z",
    id: "Path",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFbShare);
export default __webpack_public_path__ + "static/media/ic_fb_share.70cbf1ea.svg";
export { ForwardRef as ReactComponent };